var React = require('react');

function AccountIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#27788C;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.b{fill:#fff;}")),React.createElement("g",{"transform":"translate(-3674.499 16668.5)","key":1},[React.createElement("circle",{"className":"a","cx":"12","cy":"12","r":"12","transform":"translate(3674.999 -16668)","key":0}),React.createElement("path",{"className":"b","d":"M11,14H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H11a1,1,0,0,1,1,1V13A1,1,0,0,1,11,14ZM2,10v2h8V10ZM2,7V9h8V7ZM4,2A1,1,0,0,0,4,4L4,4A2,2,0,0,0,2,6H6A2,2,0,0,0,4,4,1,1,0,0,0,4,2Z","transform":"translate(3681 -16663)","key":1})])]);
}

AccountIcon.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = AccountIcon;

AccountIcon.default = AccountIcon;
